// extracted by mini-css-extract-plugin
module.exports = {"ProductGridMovingBoxes":"ProductGridMovingBoxes_ProductGridMovingBoxes__QA9ai","textView":"ProductGridMovingBoxes_textView__dSY8e","box":"ProductGridMovingBoxes_box__Fcj9a"};